import { Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTheme } from "@mui/material/styles";


import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentTab } from "../../Containers/OnBoarding/slice";

const BackButton = ({style={}}) => {
    const theme = useTheme();
  const dispatch = useDispatch();
  const {
    onBoarding: { currentTab },
  } = useSelector((state) => state);
  const previousTabHandler = () => {
    dispatch(setCurrentTab(Number(currentTab - 1)));
  };

  
  return (
    <Button
      onClick={previousTabHandler}
      sx={style}
      size="large"
      variant="contained"
      color="grey"
    >
      <ArrowBackIcon fontSize="16px" />
      <Typography variant="bold">Voltar</Typography>
    </Button>
  );
};

export default BackButton;
